/*
 * Trustpilot review-count sync.
 * Fills every `.tp-review-count[data-tp-sku]` placeholder with the live
 * product review total from Trustpilot — the same `trustbox-data` endpoint
 * the PDP TrustBox (Product Reviews MultiSource, #tp-widget-wrapper) renders
 * from — so collection cards and the PDP title always show the same number.
 * Counts are cached in localStorage for 6h to keep collection pages cheap.
 */
(function () {
  if (window.__tpReviewCount) {
    window.__tpReviewCount.scan();
    return;
  }

  var TEMPLATE_ID = '5763bccae0a06d08e809ecbb';
  var BUSINESS_UNIT_ID = '5e580ee41d562000013da592';
  var ENDPOINT = 'https://widget.trustpilot.com/trustbox-data/' + TEMPLATE_ID;
  var CACHE_PREFIX = 'tpReviewCount:';
  var CACHE_TTL = 6 * 60 * 60 * 1000;

  function cacheGet(sku) {
    try {
      var raw = localStorage.getItem(CACHE_PREFIX + sku);
      if (!raw) return null;
      var entry = JSON.parse(raw);
      if (!entry || typeof entry.n !== 'number' || Date.now() - entry.t > CACHE_TTL) return null;
      return entry.n;
    } catch (e) {
      return null;
    }
  }

  function cacheSet(sku, total) {
    try {
      localStorage.setItem(CACHE_PREFIX + sku, JSON.stringify({ t: Date.now(), n: total }));
    } catch (e) {
      /* storage full/blocked — fetch again next page */
    }
  }

  function apply(el, total) {
    if (total > 0) {
      el.textContent = '(' + total + ')';
      return;
    }
    // No Trustpilot reviews: the PDP TrustBox collapses, so hide the stars too.
    var row = el.closest('.product_rating_inline');
    if (row) {
      row.style.display = 'none';
    } else {
      el.textContent = '';
    }
  }

  var inflight = {};
  function fetchTotal(sku) {
    if (!inflight[sku]) {
      var url = ENDPOINT +
        '?businessUnitId=' + BUSINESS_UNIT_ID +
        '&locale=en-US&sku=' + encodeURIComponent(sku) +
        '&reviewsPerPage=1';
      inflight[sku] = fetch(url)
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (data) {
          if (!data) return null;
          var native = data.productReviewsSummary && data.productReviewsSummary.numberOfReviews;
          var imported = data.importedProductReviewsSummary && data.importedProductReviewsSummary.numberOfReviews;
          var total = (native ? native.total : 0) + (imported ? imported.total : 0);
          cacheSet(sku, total);
          return total;
        })
        .catch(function () { return null; });
    }
    return inflight[sku];
  }

  function scan() {
    document.querySelectorAll('.tp-review-count:not([data-tp-done])').forEach(function (el) {
      el.setAttribute('data-tp-done', '1');
      var sku = el.getAttribute('data-tp-sku');
      if (!sku) {
        // No Trustpilot SKU mapping — no reviews exist for this product.
        apply(el, 0);
        return;
      }
      var cached = cacheGet(sku);
      if (cached !== null) {
        apply(el, cached);
        return;
      }
      fetchTotal(sku).then(function (total) {
        if (total !== null) apply(el, total);
        // On fetch failure keep the server-rendered fallback count.
      });
    });
  }

  window.__tpReviewCount = { scan: scan };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scan);
  } else {
    scan();
  }
  document.addEventListener('shopify:section:load', scan);
})();
